import { useTranslation } from '../contexts/TranslationContext';
import { ArrowRight } from './Icons';
import { ActionLabel } from './ui/ActionLabel';
import { BrandButton } from './ui/BrandButton';
import { ErrorNotice } from './ui/ErrorNotice';

type GuestQuestionErrorKey = 'requestError' | 'protectionError' | 'saveError';

export function LandingGuestQuestionError({ errorKey, onGetStarted, onRetry }: {
  errorKey: GuestQuestionErrorKey;
  onGetStarted: () => void;
  onRetry?: () => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="pt-4">
      <ErrorNotice>{t(`presentation.guestQuestion.${errorKey}`)}</ErrorNotice>
      <div className="mt-4 flex flex-wrap items-center justify-center gap-3">
        <BrandButton size="sm" className="group min-h-12 w-full max-w-full px-5 sm:w-auto" onClick={onGetStarted} data-guest-error-signup>
          <ActionLabel text={`${t('hero.ctaLabel')}\n${t('common.noCardRequired')} · ${t('login.noPasswordTag')}`} />
          <ArrowRight className="h-4 w-4 shrink-0 transition-transform group-hover:translate-x-1 motion-reduce:transform-none" aria-hidden="true" />
        </BrandButton>
        {errorKey === 'saveError' && onRetry && <BrandButton variant="ghost" size="sm" className="min-h-11" onClick={onRetry}>{t('presentation.guestQuestion.submit')}<ArrowRight className="h-4 w-4" /></BrandButton>}
      </div>
    </div>
  );
}
